/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Requires_Team_AccountInputs */

const en_knp_lookup_requires_team_account = /** @type {(inputs: Knp_Lookup_Requires_Team_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Lookup requires a team account.`)
};

const fr_knp_lookup_requires_team_account = /** @type {(inputs: Knp_Lookup_Requires_Team_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La recherche KNP necessite un compte equipe.`)
};

const de_knp_lookup_requires_team_account = /** @type {(inputs: Knp_Lookup_Requires_Team_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die KNP-Suche wird ein Teamkonto benötigt.`)
};

const it_knp_lookup_requires_team_account = /** @type {(inputs: Knp_Lookup_Requires_Team_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per la ricerca KNP è necessario un account team.`)
};

const ru_knp_lookup_requires_team_account = /** @type {(inputs: Knp_Lookup_Requires_Team_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для использования сервиса KNP Lookup требуется командная учетная запись.`)
};

const es_knp_lookup_requires_team_account = /** @type {(inputs: Knp_Lookup_Requires_Team_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La búsqueda de KNP requiere una cuenta de equipo.`)
};

const zh_cn2_knp_lookup_requires_team_account = /** @type {(inputs: Knp_Lookup_Requires_Team_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP 查询需要团队帐户。`)
};

const ja_knp_lookup_requires_team_account = /** @type {(inputs: Knp_Lookup_Requires_Team_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Lookup にはチーム アカウントが必要です。`)
};

const hi_knp_lookup_requires_team_account = /** @type {(inputs: Knp_Lookup_Requires_Team_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Lookup के लिए टीम अकाउंट आवश्यक है।`)
};

const pt_pt2_knp_lookup_requires_team_account = /** @type {(inputs: Knp_Lookup_Requires_Team_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ferramenta de busca KNP requer uma conta de equipe.`)
};

/**
* | output |
* | --- |
* | "KNP Lookup requires a team account." |
*
* @param {Knp_Lookup_Requires_Team_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_requires_team_account = /** @type {((inputs?: Knp_Lookup_Requires_Team_AccountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Requires_Team_AccountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_requires_team_account(inputs)
	if (locale === "de") return de_knp_lookup_requires_team_account(inputs)
	if (locale === "it") return it_knp_lookup_requires_team_account(inputs)
	if (locale === "ru") return ru_knp_lookup_requires_team_account(inputs)
	if (locale === "es") return es_knp_lookup_requires_team_account(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_requires_team_account(inputs)
	if (locale === "ja") return ja_knp_lookup_requires_team_account(inputs)
	if (locale === "hi") return hi_knp_lookup_requires_team_account(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_requires_team_account(inputs)
	return en_knp_lookup_requires_team_account(inputs)
});